import {fade} from '@material-ui/core/styles/colorManipulator'

const styles = theme => ({
  reorderHint: {
    color: theme.palette.grey[600],
    fontSize: '13px',
    marginBottom: theme.spacing.unit * 1.5,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '10px',
    minHeight: 80,
    maxHeight: '60vh',
    overflowY: 'auto',
    paddingRight: theme.spacing.unit / 2,
  },
  card: {
    display: 'flex',
    alignItems: 'flex-start',
    gridGap: '10px',
    background: '#fff',
    border: `1px solid ${theme.palette.border ? theme.palette.border.main : '#DCE1E7'}`,
    borderRadius: 6,
    padding: '12px 12px 12px 10px',
    boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
    '&:hover': {
      borderColor: theme.palette.grey[400],
    },
    '&:hover $moveButtons, &:focus-within $moveButtons': {
      opacity: 1,
    },
    '&:hover $editButton, &:focus-within $editButton': {
      color: theme.palette.primary.main,
    },
  },
  cardDragging: {
    opacity: 0.45,
    borderStyle: 'dashed',
    boxShadow: 'none',
    background: theme.palette.surface ? theme.palette.surface[100] : '#F6F9FC',
  },
  grip: {
    background: 'none',
    border: 0,
    padding: '2px 0 0',
    color: theme.palette.grey[400],
    cursor: 'grab',
    touchAction: 'none',
    lineHeight: 0,
    '&:active': {
      cursor: 'grabbing',
    },
    '$card:hover &': {
      color: theme.palette.grey[700],
    },
  },
  positionSelect: {
    appearance: 'none',
    '-webkit-appearance': 'none',
    width: 42,
    height: 26,
    padding: '0 6px',
    border: '1px solid transparent',
    borderRadius: 5,
    background: fade(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
    fontSize: '12.5px',
    fontWeight: 800,
    textAlign: 'center',
    textAlignLast: 'center',
    cursor: 'pointer',
    '$card:hover &': {
      borderColor: fade(theme.palette.primary.main, 0.3),
    },
    '&:hover': {
      background: fade(theme.palette.primary.main, 0.14),
    },
  },
  body: {
    minWidth: 0,
    flex: 1,
  },
  text: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.4,
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  textEmpty: {
    fontStyle: 'italic',
    fontWeight: 500,
    color: theme.palette.grey[600],
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gridGap: '8px',
    marginTop: 5,
  },
  type: {
    fontSize: '11.5px',
    fontWeight: 700,
    color: theme.palette.grey[600],
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badge: {
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    padding: '3px 7px',
    borderRadius: 9,
    background: fade(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
  },
  defaultBadge: {
    background: theme.palette.grey[200],
    color: theme.palette.grey[700],
  },
  actions: {
    display: 'flex',
    alignItems: 'flex-start',
    gridGap: '2px',
    paddingTop: 1,
  },
  moveButtons: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '2px',
    opacity: 0,
    transition: 'opacity 0.12s',
  },
  moveButton: {
    background: 'none',
    border: 0,
    padding: '2px 3px',
    borderRadius: 4,
    color: theme.palette.grey[700],
    lineHeight: 0,
    '&:hover:not(:disabled)': {
      background: theme.palette.grey[100],
    },
    '&:disabled': {
      color: theme.palette.grey[300],
      cursor: 'not-allowed',
    },
  },
  editButton: {
    background: 'none',
    border: 0,
    padding: 5,
    borderRadius: 5,
    color: theme.palette.grey[400],
    lineHeight: 0,
    '&:hover': {
      background: fade(theme.palette.primary.main, 0.08),
      color: theme.palette.primary.main,
    },
  },
  status: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.primary.main,
    minHeight: 20,
    marginTop: theme.spacing.unit * 1.5,
  },
})

export default styles
